import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { CREATE_CREDIT, CREATE_TRANSACTION, filterCredit, UPDATE_CREDIT, whoami } from './../../graphqlClient/graphql';
import { useMutation } from '@apollo/client';
import Notifications from './../notifications/Notifications';
import { Button, Container, Typography, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal, Box, LinearProgress } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
interface form {
    planType: string;

}

const CheckoutForm = ({ planType }: form) => {
    const navigate = useNavigate();
    const stripe: any = useStripe();
    const elements = useElements();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [credit, setCredit] = useState<any>([]);
    const [CreateTransactionMutation, { data }] = useMutation(CREATE_TRANSACTION);
    const [CreateCreditMutation, { data: Credit }] = useMutation(CREATE_CREDIT);
    const [UpdateCreditMutation, { data: UpdateCreditInput }] = useMutation(UPDATE_CREDIT);

     useEffect(() => {
            checkCredit()
            //handleCreateAllCategories()
        }, [])

    const handleAddCredit = async (user: any) => {
        setLoading(true)

        const dataToSend = {
            user: user,
            active: true,
            amount: 3,
            amountPdf: 3,
            amountInterview: 0,
            type : planType
        }
        if (planType == 'basic') {
            dataToSend.amount = 10
            dataToSend.amountPdf = 10
            dataToSend.amountInterview = 3
        } else if (planType == 'plus') {
            dataToSend.amount = 30
            dataToSend.amountPdf = 30
            dataToSend.amountInterview = 10
        }
        console.log('dataToSend add credit', dataToSend)

        // dataToSend.id = dataToSend._id



        try {

            const createCreditInput = dataToSend
            console.log('createCreditInput', dataToSend)

            const result = await CreateCreditMutation({
                variables: {
                    createCreditInput
                },
                onCompleted: ({ createCredit }) => {

                    console.log('credit created== > ', createCredit);
                    const notData = {
                        type: 'success',
                        message: `Credits created Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }

                    Notifications(notData)
                    setSuccess(true)
                    setLoading(false)

                    //navigate('/login')
                    //setCompany(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            setLoading(false)
            console.log("Error at create credit", error)

        }
        

    };
    const handleUpdateCredit = async (creditId:any) => {
        let res:any = {}
        const dataToSend = {
            id: creditId,
            active: false,
        }
        setLoading(true)

        //console.log('dataToSend handleUpdateCredit', dataToSend)
        try {

            const updateCreditInput = dataToSend
            console.log('updateCreditInput', dataToSend)

            const result = await UpdateCreditMutation({
                variables: {
                    updateCreditInput
                },
                onCompleted: ({ updateCredit }) => {

                    console.log('credit updated== > ', updateCredit);
                    if(updateCredit._id){
                        res =  updateCredit
                    }
                    setLoading(false)

                    //navigate('/login')
                    //setCompany(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error at create credit", error)
            setLoading(false)

        }

        return res;

    };

    const checkCredit = async () => {
        setLoading(true)
        const u: any = await getUser();

        if (!u._id) {
            const notData = {
                type: 'error',
                message: "Undefined User",
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            return
        }

        const objToSend = {
            //startDate,
            //endDate,
            //empresa:empresa
            //category:selectedCategory?._id || '',
            "active": true,
            "user": u._id,
        }
        //setIsLoadingCompaniesByFilter(true)
        console.log('objToSend', objToSend)

        const result = await filterCredit(objToSend)
        console.log('filterCredit result ==>>', result)
        if (result.length == 0) {
            console.log('call add credit')
            //await handleAddCredit(u);
        } else {
            setCredit(result)
            console.log('checkCredit', result)
            console.log('planType', planType)
        }
        setLoading(false)
        return;
    }

    const getUser = async () => {
        try {
            const user: any = await whoami();
            console.log('user ==>>', user)
            return user;
        }
        catch (error) {
            console.log("Erro no getUser >>>>>", error)
            return error;
        }
    }

    const handleAddTransaction = async (data?: any) => {

        const dataToSend = data
        //console.log('dataToSend handleAddTransaction', dataToSend)
        setLoading(true)
        try {

            const createTransactionInput = dataToSend
            console.log('createTransactionInput', dataToSend)

            const result = await CreateTransactionMutation({
                variables: {
                    createTransactionInput
                },
                onCompleted: async ({ createTransaction }) => {

                    console.log('createTransaction == > ', createTransaction);
                    const notData = {
                        type: 'success',
                        message: `Created Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }
                    //await getCarrerguideAsync()
                    Notifications(notData)
                    
                    
                    if (createTransaction._id) {
                        if(credit.length){
                            for(let a=1;a<credit.length;a++){
                                const crediId = credit[a]._id
                                await handleUpdateCredit(crediId)
                            }
                        }

                        handleAddCredit(data.user)
                        
                    }

                    /*  if(index < itensList.length){
                       index++
                       handleCreateAllCategories()
                     } */
                    //navigate('/login')
                    //setCategory(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Error stripe", error.message)

        }
        console.log('Transaction created');
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setLoading(true);

        if (!stripe || !elements) return;

        const cardElement = elements.getElement(CardElement);

        try {
            const res = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });
            console.log('res', res)
            const paymentMethod = res.paymentMethod
            const userCheck: any = await getUser();
            // Enviar para o backend para criar a assinatura
            if (!paymentMethod?.id) {
                console.error('Failed to create payment method', paymentMethod);
                throw new Error('Payment method creation failed');
                return;
            }
            const dataToSend = {
                user: userCheck._id,
                message: paymentMethod.id,
                planType: planType,
                email: userCheck.email,
                name: planType == 'basic' ? 'Most Popular' : 'Best Value'
            }
            handleAddTransaction(dataToSend)

        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {loading ? (
                            <Box sx={{ width: '100%', maxWidth:800,margin:'0 auto' }}>
                                <LinearProgress />
                            </Box>
                        ) : null}
            {
                !success ? <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 25 }}>
                        <CardElement />
                    </div>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <Button type="submit" disabled={loading || !stripe}>
                        {loading ? 'Processing...' : 'Subscribe to plan'}
                    </Button>
                </form>
                    : <>
                        <p>Subscription successful! Thank you for joining us.</p>
                        <Button onClick={() => { navigate('/invoices') }}>Check your invoice here</Button>
                    </>
            }
        </>


    );
};

export default CheckoutForm;